import { THEME_COLORS } from "../../../../../color";
import { useSelector } from "react-redux";
const CarbonSmallCard = ({
  icon,
  title,
  value,
  description,
  descriptionBgClass,
  empvalue,
}) => {
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;

  return (
    <div className="w-full sm:w-[48%] lg:w-[24%] bg-[#E6EEEC] rounded-lg shadow-md pt-4 border border-[#0087A359] flex flex-col justify-between">
      {/* Icon & Title */}
      <div className="flex items-center gap-2 px-3">
        <div className="px-3 rounded-lg shadow-sm flex items-center justify-center w-12 h-12 ">
          {typeof icon === "string" ? (
            <img src={icon} alt={title} className="w-4 h-4 object-contain" />
          ) : (
            <span className="text-[#42B4A6] text-3xl">{icon}</span>
          )}
        </div>
        <span className="text-gray-800 font-calibri font-light text-[13px] leading-5 tracking-[0%]">
          {title}
        </span>
      </div>

      {/* Value */}
      <div
        className={` ${
          !isPermissionCompleted ? "blur-sm opacity-40 pointer-events-none" : ""
        }`}
      >
        <div className="text-center mt-3">
          <div className="font-calibri font-bold text-[#002F22] text-[26px]">
            {value}
          </div>
          <div className="text-[10px] text-gray-700 font-bold mt-1">
            {empvalue}
          </div>
        </div>

        {/* Description */}
        <div
          className={`text-white text-[12px] text-center rounded-b-lg py-3 mt-4 ${descriptionBgClass}`}
          style={{ backgroundColor: THEME_COLORS.green }}
        >
          {description}
        </div>
      </div>
    </div>
  );
};

export default CarbonSmallCard;
